export default __webpack_public_path__ + "static/media/400.21238e5a.gif";